<template>
    <article class="accessIndex">
      <div class="accessIndex__reload">
        <v-hover>
          <div
            @click="pagination_query=false;filterEvents(true);date_available=false;"
            slot-scope="{ hover }"
            class="accessIndex__reload--container"
            :class="hover?'accessIndex__interaction--hover':''">
            <img src="../../../assets/img/reload_blue.svg">
          </div>
        </v-hover>
        <p class="accessIndex__text--title">
          <!-- {{!hasAlreadyFilter?'Accesos en '+location_name :'Accesos en '+location_name+' '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}} -->
          {{ 'Eventos en '+location_name+' '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
        </p>
      </div>
      <div class="accessIndex__general_info--actual_users">
        <section class="trainers__header">
              <div class="trainers__header--title">
              <v-breadcrumbs style="width: 100%">
                  <v-icon slot="divider">chevron_right</v-icon>
                  <v-breadcrumbs-item
                  v-if="getUserType() !== 'Counter'"
                  @click="$router.push({name: 'AlarmsIndex'})">
                  Resumen
                  </v-breadcrumbs-item>
                  <v-breadcrumbs-item>
                  {{ location_name }}
                  </v-breadcrumbs-item>
              </v-breadcrumbs>
              </div>
          </section>
          <div class="trainers__header_sublocation">

              <div
                  style="cursor: pointer"
                  class="trainers__header_sublocation--time_zone"
                  v-if="accesses.length>0"
                  @click="makeExcelReport()">
                  <p>EXPORTAR REPORTE</p>
              </div>

              <app-date-picker
              @filterQuery="pagination_query=false;filterEventsByButton($event)"></app-date-picker>
          </div>
  
      </div>
      <v-data-table
     
        :headers="headers"
        :items="accesses"
        :pagination.sync="sorter"
        hide-actions
        class="elevation-1">
        <template
            slot="items"
            slot-scope="props">
            <td>{{ props.item.event_type }}</td>
            <td>{{ props.item.area }}</td>
            <td>{{ props.item.user }}</td>
            <td>{{ dateFormatText(props.item.date) }}</td>
          </template>
      </v-data-table>
  
  
      <div >
          <div
          v-if="accesses.length>0"
          class="accessIndex__pagination">
          <v-pagination
              color="light-blue darken-3"
              v-model="pagination.page"
              :length="pages"></v-pagination>
          <label
              class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
          <label
              class="accessIndex__pagination--current_text"
              v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
              {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
          </label>
          <label
              class="accessIndex__pagination--current_text"
              v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
          </div>
      </div>
  
  
  
  
      <modal-invitation
        @handleCancelModalInvitation="cancelModalInvitation"
        v-if="active_modal_invitation">
      </modal-invitation>
      <modal-reward-user
        @handleCancelModalRewardUser="cancelModalRewardUser"
        v-if="show_modal_reward_user">
      </modal-reward-user>
    </article>
  </template>
  
  <script>
  import ModalInvitation from '../../views/invitations/ModalInvitation'
  import ModalRewardUser from '../../views/invitations/ModalRewardUser'
  
  export default {
      data(){
          return{
              sorter: {sortBy: 'in_date', descending: true, rowsPerPage: -1},
              saved_default_option:false,
              pagination_query:false,
              date_available:false,
              invitations_size:0,
              date: new Date().toISOString().substr(0, 10),
              date2: new Date().toISOString().substr(0, 10),
              menu: false,
              menu2:false,
              datePickerFirstClick:false,
              hasAlreadyFilter:false,
              filterSearchedDate:new Date().toISOString().substr(0, 10),
              filterSearchedDate2:new Date().toISOString().substr(0, 10),
              initialRender:true,
              pages:2,
              months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
              pagination: {page:1,rowsPerPage:24},
              accesses: [],
              headers: [
                  {text: 'Tipo de evento', value: 'event_type'},
                  {text: 'Area', value: 'area'},
                  {text: 'Usuario', value: 'user'},
                  {text: 'Fecha y hora del evento', value: 'date'}
              ],
              titlelocation:'',
              months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
              location_id: '',
              location_name: '',
              location_timezone: '',
              active_modal_invitation: false,
              show_modal_reward_user: false,
              device: false,
              pageSize:24,
              current:1,
              finalAccess: []
          }
      },
      components: {
          'modal-invitation': ModalInvitation,
          'modal-reward-user': ModalRewardUser
      },
      watch: {
          'pagination.page': function (val, oldVal) {
              if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){
  
              }
              else if(oldVal!=val&&val!=null&&oldVal!=null){
                  this.pagination_query=true;
                  this.filterEvents(false);
  
              }
          },
  
  
  
  
      },
  
  
      methods:{
  
          prev() {
           this.current--;
           this.paginated()
           console.log('backk')
          },
          next() {
           this.current+1;
           this.paginated()
          console.log('nexttt')
          },
          paginated() {
            this.finalAccess=[]
            console.log('this current', this.current)
            var indexStart = (this.current - 1) * this.pageSize
            var indexEnd = indexStart + this.pageSize
  
            console.log('this.pageSize', this.pageSize)
  
            console.log('this.indexStart', indexStart)
            console.log('indexEnd', indexEnd)
            this.finalAccess = this.accesses.slice(indexStart, indexEnd)
            console.log('this.accesses', this.finalAccess)
          },
  
          modifyDateFormatToStatus(datex){
              var entries=datex.split('/');
              entries=[entries[2],entries[0],entries[1]];
              return entries.join("-");
          },
          dateFormat(datex){
              var sections=datex.split("-");
              var index=Number(sections[1])-1;
              sections[1]=this.months[index];
              datex=sections.join("/");
              return datex;
          },
          dateFormatText(datex){
              const moment = require('moment-timezone');
              var time_zone = this.location_timezone;
              if(time_zone !== '' && time_zone !== null){
                  var date = moment(datex).tz(time_zone).format("MM/DD/YYYY - h:mm a")
                  console.log('datex', datex)
                  console.log('date timezone', date)
              }else{
                  var date = moment(datex).format("MM/DD/YYYY - h:mm a")
              }
              var sections=date.split("/");
              var index=Number(sections[0])-1;
              sections[0]=this.months_text[index];
              datex=sections.join(" ");
  
              return datex;
          },

          filterEventsByButton(dates){
              var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
              this.date =this.modifyDateFormatToStatus(object.date_from);
              this.date2 =this.modifyDateFormatToStatus(object.date_to);
              if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
                  this.datePickerFirstClick=true;
              }
              // alert(this.datePickerFirstClick+this.date+this.date2);
              if(this.datePickerFirstClick){
                  this.hasAlreadyFilter=true;
                  this.filterSearchedDate=this.date;
                  this.filterSearchedDate2=this.date2;
                  this.filterEvents(false);
              }
          },
          filterEvents(defaultOption){
              let accessData = [];
              if(this.pagination_query){
                  defaultOption=this.saved_default_option;
              }
              else{
                  this.pagination.page=1;
              }
              this.saved_default_option=defaultOption;
              //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
              // var initialDate=new Date().toISOString().substr(0, 10);
              // var lastDate=new Date().toISOString().substr(0, 10);
              var initialDate= ""
              var lastDate=""
              if(!defaultOption){
                  initialDate=this.date;
                  lastDate=this.date2;
                  // initialDate=this.date;
                  // lastDate=this.date2;
              }
              else if(this.initialRender&&this.$route.params.filter){
                  this.initialRender=false;
                  initialDate=this.$route.params.date;
                  lastDate=this.$route.params.date2;
                  this.date=this.$route.params.date;
                  this.date2=this.$route.params.date2;
                  this.filterSearchedDate=this.$route.params.date;
                  this.filterSearchedDate2=this.$route.params.date2;
                  this.datePickerFirstClick=true;
                  this.hasAlreadyFilter=true;
                  this.saved_default_option=false;
              }
              else{
                  this.date= new Date().toISOString().substr(0, 10);
                  this.date2= new Date().toISOString().substr(0, 10);
                  this.datePickerFirstClick=false;
                  this.hasAlreadyFilter=false;
              }
              try {
                const data={ 
                      location_id: this.$route.params.id,
                      offset_time: new Date().getTimezoneOffset(),
                      first_date: initialDate,
                      last_date: lastDate,
                      page:this.pagination.page,
                      current:!this.hasAlreadyFilter}

                  this.$http.post('alarm/get_event_reports_admin',{data:this.encrypt(data).toString()},{
                  headers:
                      {
                      "X-Device-ID" : this.getDeviceId(),
                      "Authorization" : 'Bearer ' + this.getUserToken()
                      }
                  }
                  ).then(function(response){
                      console.log('index_location ', response)
                      // this.location_name = response.body.data.location_name;
                      this.location_timezone = response.body.location_time_zone;
                      console.log('this.location_timezone', this.location_timezone)
                      this.accesses=[];
                      if(response.body.meta != undefined && response.body.meta != null){
                          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                          this.checkToken(response.body.meta.authentication_token)
                          }
                      }

                      var vm =this;
                      var temp = response.body.data;

                          for(var user in temp){

                              vm.accesses.push({
                                  event_type: temp[user]["event_type"],
                                  area: temp[user]["area"],
                                  user: temp[user]["user_name"],
                                  date: temp[user]["date"]
                              })
                          }
  
                      this.invitations_size=response.body.total_elements;
                      this.pages=response.body.pages;
                      console.log('this.pages', this.pages)
  
                    //   console.table(vm.accesses);
                      this.loaded = true;
                      this.date_available=true;
                      }, function(response){
                      if (response.body.data.message != null &&
                          response.body.data.message != undefined &&
                          response.body.data.message != '' ){
                          alert(response.body.data.message)
                      }else{
                          alert(response.body.data)
                      }
                  })
              } catch (e) {
                  alert(e.message)
              }
          },
          cancelModalInvitation(){
              this.active_modal_invitation = false;
          },
          cancelModalRewardUser(){
              this.show_modal_reward_user = false;
          },
          makeExcelReport() {
              let accessData = [];
              let defaultOption = this.saved_default_option;
              let initialDate = ""
              let lastDate = ""
              if (!defaultOption) {
                  initialDate = this.date;
                  lastDate = this.date2;
              }
              else if (this.initialRender && this.$route.params.filter) {
                  initialDate = this.$route.params.date;
                  lastDate = this.$route.params.date2;
              }

              const data={ 
                      location_id: this.$route.params.id,
                      offset_time: new Date().getTimezoneOffset(),
                      first_date: initialDate,
                      last_date: lastDate,
                    //   page:this.pagination.page,
                      current:!this.hasAlreadyFilter}

              this.$http.post('alarm/get_event_reports_admin',{data:this.encrypt(data).toString()},{
                  headers:
                      {
                      "X-Device-ID" : this.getDeviceId(),
                      "Authorization" : 'Bearer ' + this.getUserToken()
                      }
                  }
              ).then(function (response) {
                  console.log('index_location ', response)
  
                  if (response.body.meta != undefined && response.body.meta != null) {
                      if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                          this.checkToken(response.body.meta.authentication_token)
                      }
                  }
                  // this.accesses = response.body.data;
                  var vm = this;
                  var temp = response.body.data;
  
  
                  if(response.body.device){
                      this.device = true
                  }
  
                      // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
                      for (var user in temp) {

                          accessData.push({
                                  event_type: temp[user]["event_type"],
                                  area: temp[user]["area"],
                                  user: temp[user]["user_name"],
                                  date: temp[user]["date"]
                              })
                      }
  
                  let excelData = []
  
                  if(vm.device == true){
  
                       excelData = accessData.map(access => {
                          let accessInfo = {};
                          accessInfo[ "Tipo de evento" ] = access.event_type;
                          accessInfo[ "Area" ] = access.area;
                          accessInfo[ "Usuario" ] = access.user;
                          accessInfo[ "Fecha y hora del evento" ] = this.dateFormatText(access.date);
                          return accessInfo;
                      })
                  }else{
  
                      excelData = accessData.map(access => {
                          let accessInfo = {};
                          accessInfo[ "Tipo de evento" ] = access.event_type;
                          accessInfo[ "Area" ] = access.area;
                          accessInfo[ "Usuario" ] = access.user;
                          accessInfo[ "Fecha y hora del evento" ] = this.dateFormatText(access.date);
                          return accessInfo;
                      })
                  }
  
                  // Stylize the excel, column width
                  let colStyle = [];
  
                  Object.keys(excelData[ 0 ]).map(title => {
                      colStyle.push({ wch: title.length + 1 });
                  });

                  excelData.map((accessInfo) => {
                      Object.values(accessInfo).map((values, index) => {
                        console.log('vsluesss', values)
                        console.log('index', index)
                          if (values.length + 1 > colStyle[ index ].wch) {
                              colStyle[ index ].wch = values.length + 1;
                          }
                      })
                  });
  
  
                  let data = XLSX.utils.json_to_sheet(excelData);
                  data[ "!cols" ] = colStyle;
                  const workbook = XLSX.utils.book_new();
                  let filename = "Reporte de eventos general"
  
                  XLSX.utils.book_append_sheet(workbook, data, filename);
                  XLSX.writeFile(workbook, `${filename}.xlsx`);
  
              }, function (response) {
                  if (response.body.data.message != null &&
                      response.body.data.message != undefined &&
                      response.body.data.message != '') {
                      alert(response.body.data.message)
                  } else {
                      alert(response.body.data)
                  }
              })
          },
      }, /* Closed methods */
      mounted(){
          // this.pagination.rowsPerPage=12;
          this.filterEvents(true);
          this.titlelocation=this.$route.params.namex;
          this.location_id = this.$route.params.id;
          this.location_name = this.$route.params.namex;

  
      }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/views/alarms/Reports.vue